import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faClock, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'; // Importamos íconos de marcas para redes sociales
import './Ubicacion.css';

export default function Ubicacion() {
    // Información del local actualizada
    const infoLocal = {
        direccion: "Av Fuerza Aérea 3850, Córdoba, Argentina",
        telefono: "+54 9 3513 47-5771",
        email: "motos.comercial@grupoantun.com.ar",
        // Horarios ajustados al formato proporcionado
        horarios: [
            { dias: "Lunes a Viernes", horario: "9:00 a 19:00" },
            { dias: "Sábados", horario: "9:30 a 13:30" },
        ],
        // Nuevas URLs de redes sociales y WhatsApp (con el mismo número de teléfono)
        redes: [
            { icon: faInstagram, url: "https://www.instagram.com/ruta20.motos", name: "Instagram" },
            { icon: faWhatsapp, url: "https://wa.me/549351475771?text=Hola%20Ruta20%20Motos", name: "WhatsApp" },
        ]
    };

    const handleDireccionesClick = () => {
        // Abre Google Maps con la nueva dirección
        const direccionEncoded = encodeURIComponent(infoLocal.direccion);
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${direccionEncoded}`, '_blank');
    };

    return (
        <div className='ubicacion-section'>
            <div className='ubicacion-container'>
                <div className='ubicacion-header'>
                    <h2 className='ubicacion-title'>UBICACION</h2>
                    <p className='ubicacion-subtitle'>
                        Visitanos en nuestro consecionario para conocer todos los vehículos disponibles
                    </p>
                </div>

                <div className='ubicacion-content'>
                    <div className='ubicacion-info'>
                        <div className='info-card'>
                            {/* Dirección */}
                            <div className='info-item'>
                                <div className='info-icon-container'>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} className='info-icon' />
                                </div>
                                <div className='info-content'>
                                    <h4 className='info-titulo'>Dirección</h4>
                                    <p className='info-descripcion'>{infoLocal.direccion}</p>
                                </div>
                            </div>

                            {/* Teléfono / WhatsApp */}
                            <div className='info-item'>
                                <div className='info-icon-container'>
                                    <FontAwesomeIcon icon={faPhone} className='info-icon' />
                                </div>
                                <div className='info-content'>
                                    <h4 className='info-titulo'>Teléfono / WhatsApp</h4>
                                    <a href={`tel:${infoLocal.telefono}`} className='info-descripcion'>{infoLocal.telefono}</a>
                                </div>
                            </div>

                            {/* Email */}
                            <div className='info-item'>
                                <div className='info-icon-container'>
                                    <FontAwesomeIcon icon={faEnvelope} className='info-icon' />
                                </div>
                                <div className='info-content'>
                                    <h4 className='info-titulo'>Email</h4>
                                    <a href={`mailto:${infoLocal.email}`} className='info-descripcion'>{infoLocal.email}</a>
                                </div>
                            </div>

                            {/* Horarios de Atención */}
                            <div className='horarios-section'>
                                <div className='horarios-header'>
                                    <FontAwesomeIcon icon={faClock} className='horarios-icon' />
                                    <h4 className='horarios-titulo'>Horarios de Atención</h4>
                                </div>
                                <div className='horarios-lista'>
                                    {infoLocal.horarios.map((horario, index) => (
                                        <div key={index} className='horario-item'>
                                            <span className='horario-dias'>{horario.dias}</span>
                                            <span className='horario-horas'>{horario.horario}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Nueva Sección de Redes Sociales */}
                            <div className='social-media-section'>
                                <h4 className='social-media-title'>Síguenos</h4>
                                <div className='social-links'>
                                    {infoLocal.redes.map((red, index) => (
                                        <a
                                            key={index}
                                            href={red.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='social-link-item'
                                            aria-label={`Visita nuestro ${red.name}`}
                                        >
                                            <FontAwesomeIcon icon={red.icon} className='social-icon' />
                                        </a>
                                    ))}
                                </div>
                            </div>
                            <br />
                            <br />
                            <button
                                className='direcciones-btn'
                                onClick={handleDireccionesClick}
                            >
                                <FontAwesomeIcon icon={faMapMarkerAlt} />
                                Cómo llegar
                            </button>
                        </div>
                    </div>

                    <div className='ubicacion-mapa'>
                        <div className='mapa-container'>
                            {/* Mapa de Google Maps actualizado para Av Fuerza Aérea 3850, Córdoba */}
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3404.918967406979!2d-64.24941012521921!3d-31.41895317212136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94329971988891d9%3A0x80356784d56d10f3!2sAv.%20Fuerza%20A%C3%A9rea%20Argentina%203850%2C%20C%C3%B3rdoba!5e0!3m2!1ses!2sar!v1700323200000!5m2!1ses!2sar"
                                className='google-map'
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Ubicación Grupo Antun Motos"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}